import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=70cb991c&scoped=true&"
import script from "./logs.vue?vue&type=script&lang=js&"
export * from "./logs.vue?vue&type=script&lang=js&"
import style0 from "./logs.vue?vue&type=style&index=0&id=70cb991c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb991c",
  null
  
)

export default component.exports